dmx.Actions({
    'f7.preloader.show': function(options) {
        Framework7.instance.preloader.show();
    },
    
    'f7.preloader.hide': function(options) {
        Framework7.instance.preloader.hide();
    }
});